var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHourHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M25.7671,14L25.7671,27.346",
    strokeWidth: 2,
    stroke: "#003c8f",
    id: "path_0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M15.4971,26.346L26.5521,26.346",
    strokeWidth: 2,
    stroke: "#003c8f",
    id: "path_1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M24,24m-23,0a23,23 0,1 1,46 0a23,23 0,1 1,-46 0",
    strokeWidth: 2,
    stroke: "#003c8f",
    id: "path_2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M24,24m-17,0a17,17 0,1 1,34 0a17,17 0,1 1,-34 0",
    strokeWidth: 2,
    stroke: "#003c8f",
    id: "path_3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHourHome);
export default __webpack_public_path__ + "static/media/ic_hour_home.3431c4387689c9e6007d59fa225fc6e4.svg";
export { ForwardRef as ReactComponent };